/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import firebase from "firebase";
import { useDispatch } from "react-redux";
import { DashboardCard } from "./dashboardCard";
import { storeExpiredLicense, storeExpiredInsuarnce } from "../../redux/actions/expired-vehicle";
import { storeNewContarct, storeExpiredContarct } from "../../redux/actions/expiredContracts";
import firebaseConfig from "../../firebase/firebase";

export const HomeDashboard = ({
  tasks,
  setTasks,
  completedVisits,
  setCompletedVisits,
  notOpenedVisits,
  setNotOpenedVisits,
  startVisits,
  setStartVisits,
}) => {
  const dispatch = useDispatch();

  const [licenseList, setLicenseList] = useState([]);
  const [insuranceList, setInsuranceList] = useState([]);
  const [expiredContractList, setExpiredContractList] = useState([]);
  const [newContractList, setNewContractList] = useState([]);
  const [customerComplainsList, setCustomerComplainsList] = useState([]);
  const [qualityComplainsList, setQualityComplainsList] = useState([]);
  const [taskComplainsList, setTaskComplainsList] = useState([]);

  useEffect(() => {
    const tasksList = [];
    const completedList = [];
    const notOpenedList = [];
    const startList = [];
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    firebase
      .database()
      .ref(`ScheduleTasks/${year}/${month}`)
      .once("value", (task) => {
        if (task.val() !== null) {
          Object.values(task.val()).forEach((val) => {
            tasksList.push(val);
            if (val.TaskStatus === "Complete") {
              completedList.push(val);
            }
            if (
              val.TaskStatus === "NotReady" ||
              val.TaskStatus === "Ready" ||
              val.TaskStatus === "Cancel" ||
              val.TaskStatus === "Failure"
            ) {
              notOpenedList.push(val);
            }
            if (val.TaskStatus === "Start") {
              startList.push(val);
            }
          });
        }
        setCompletedVisits(completedList);
        setNotOpenedVisits(notOpenedList);
        setStartVisits(startList);
        setTasks(tasksList);
      })
      .then(() => {
        const licenseData = [];
        firebase
          .database()
          .ref("DashBoardAlerts/VehicleLicenseExpireData")
          .once("value")
          .then((license) => {
            Object.values(license.val()).forEach((val) => {
              licenseData.push({ val });
            });
            setLicenseList(licenseData);
            dispatch(storeExpiredLicense({ licenseData }));
          });
      })
      .then(() => {
        const insuranceData = [];
        firebase
          .database()
          .ref("DashBoardAlerts/ExpiredVehiclesCarInsuranceData")
          .once("value")
          .then((dataInsurance) => {
            if (dataInsurance.val() !== null) {
              Object.values(dataInsurance.val()).forEach((val) => {
                insuranceData.push({ val });
              });
              setInsuranceList(insuranceData);
              dispatch(storeExpiredInsuarnce({ insuranceData }));
            }
          });
      })
      .then(() => {
        const contractData = [];
        firebase
          .database()
          .ref("DashBoardAlerts/ExpiredContract")
          .once("value")
          .then((dataContract) => {
            Object.values(dataContract.val()).forEach((val) => {
              contractData.push({ val });
            });
            setExpiredContractList(contractData);
            dispatch(storeExpiredContarct({ contractData }));
          });
      })
      .then(() => {
        const newContract = [];
        firebase
          .database()
          .ref(`DashBoardAlerts/NewContract/${year}/${month}`)
          .once("value")
          .then((New) => {
            if (New.val() !== null) {
              Object.values(New.val()).forEach((val) => {
                newContract.push({ val });
              });
              setNewContractList(newContract);
              dispatch(storeNewContarct({ newContract }));
            }
          });
      })
      .then(() => {
        const customerComplains = [];
        firebase
          .database()
          .ref("DashBoardAlerts/OpenComplaintsPublic")
          .once("value")
          .then((CustomerComplaints) => {
            if (CustomerComplaints.val() !== null) {
              Object.values(CustomerComplaints.val()).forEach((val) => {
                customerComplains.push({ val });
              });
              setCustomerComplainsList(customerComplains);
            }
          });
      })
      .then(() => {
        const qualityComplains = [];
        firebase
          .database()
          .ref("DashBoardAlerts/OpenComplaintsQuality")
          .once("value")
          .then((Quality) => {
            if (Quality.val() !== null) {
              Object.values(Quality.val()).forEach((val) => {
                qualityComplains.push({ val });
              });
              setQualityComplainsList(qualityComplains);
            }
          });
      })
      .then(() => {
        const taskComplains = [];
        firebase
          .database()
          .ref("DashBoardAlerts/OpenTaskCompints")
          .once("value")
          .then((TaskComplaints) => {
            if (TaskComplaints.val() !== null) {
              Object.values(TaskComplaints.val()).forEach((val) => {
                taskComplains.push({ val });
              });
              setTaskComplainsList(taskComplains);
            }
          });
      });
  }, []);

  return (
    <div>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0 text-dark">Dashboard</h1>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <DashboardCard
              name={tasks?.length}
              color="#17a2b8"
              value="Total Visits / Month"
              icon="fas fa-shopping-bag"
              link="/all-tasks"
            />

            <DashboardCard
              name={completedVisits?.length}
              color="#007bff"
              value="Total Completed / Month Visits"
              icon="fas fa-calendar-check "
              link="/completed-tasks"
            />

            <DashboardCard
              name={notOpenedVisits?.length}
              color="#343a40"
              value="Not Opened Tasks / This Month"
              icon="fas fa-window-close"
              link="/not-opened-tasks"
            />

            <DashboardCard
              name={startVisits?.length}
              color="#114e60"
              value=" Now Open Tasks / This Month"
              icon="fas fa-play-circle"
              link="/started-tasks"
            />

            <DashboardCard
              name={licenseList?.length}
              color="#28a745"
              value="Expired Vehicle / license"
              icon="fas fa-id-badge"
              link="/expired-license"
            />

            <DashboardCard
              name={insuranceList?.length}
              color="#ffc107"
              value=" Expired Vehicle / Insurance"
              icon="fas fa-car"
              link="/expired-car-insurance"
            />

            <DashboardCard
              name={expiredContractList?.length}
              color="#dc3545"
              value="Total Expired / Contracts"
              icon="fas fa-file-contract"
              link="/expired-contracts"
            />

            <DashboardCard
              name={newContractList?.length}
              color="#6c757d"
              value="Total New Created / Contracts"
              icon="fas fa-folder-plus"
              link="/new-created-contracts"
            />

            <DashboardCard
              name={customerComplainsList?.length}
              color="teal"
              value="Total Customers / Complaints"
              icon="fas fa-users"
              link="/customers-complains"
            />

            <DashboardCard
              name={qualityComplainsList?.length}
              color="#325288"
              value="Total Quality / Complaints"
              icon="fas fa-battery-half"
              link="/quality-complains"
            />

            <DashboardCard
              name={taskComplainsList?.length}
              color="#57837B"
              value="Total Tasks / Complaints"
              icon="fas fa-tasks"
              link="/task-complains"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
